<template>
  <div class="message-page">
    <!-- Hero 区 -->

    <!-- 主体内容 -->
    <div class="container msg-body">

      <!-- 大赛简介 -->
      <section class="msg-section">
        <div class="msg-section-content">
          <h2 class="msg-section-title">2026年3D大赛等你来！</h2>
          <p class="msg-section-subtitle">第19届全国3D大赛 · 数字化设计与制造大赛</p>
          <p class="msg-desc">
            全国三维数字化创新设计大赛（简称"3D大赛"）历经十八载耕耘，已成为
            <strong>全国规模最大的三维设计赛事</strong>，每年吸引
            <strong>100+ 万名选手</strong>同台竞技。
          </p>
          <p class="msg-desc">
            今年，"数字化设计与制造大赛"全面升级，以
            <strong>「设计创意 · 数智制造」</strong>为主题，聚焦
            AI + 数字化设计、数字化检测、数字化制造 / 3D 打印等硬核技术，
            立足专业课程升级新要求，带你从创意构思到打印实物，完整体验工业级全流程创新闭环。
          </p>
          <p class="msg-desc">
            大赛设<strong>高职高专组、研究生 / 本科生组</strong>及<strong>青少年组</strong>。
            只要作品能体现"程序之美"与"设计之美"的融合，这里就是你的主场！
          </p>
          <p class="msg-desc msg-sponsor">
            北京清软海芯科技有限公司为大赛技术支持单位，参赛选手可使用
            <strong>LogoUp 3D</strong> 软件设计作品参赛。
          </p>
        </div>
      </section>

      <!-- 大赛安排 -->
      <section class="msg-section">
        <div class="msg-section-content">
          <h2 class="msg-section-title">大赛安排</h2>
          <table class="msg-table">
            <thead>
              <tr>
                <th>赛程阶段</th>
                <th>时间</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>比赛报名 / 项目作品提交</td>
                <td class="msg-time">6月5日 — 8月31日</td>
              </tr>
              <tr>
                <td>初赛 / 校赛选拔</td>
                <td class="msg-time">6月 — 8月</td>
              </tr>
              <tr>
                <td>省 / 区域赛选拔</td>
                <td class="msg-time">9月 — 10月</td>
              </tr>
              <tr>
                <td>国赛 / 总决赛</td>
                <td class="msg-time">11月</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <!-- 操作按钮 -->
      <section class="msg-actions">
      
        <div
          v-for="(item, index) in actionLinks"
          :key="item.url"
          class="msg-action-row"
        >
          <a
            href="#"
            class="msg-btn"
            @click.prevent="openExternal(item.url)"
          >{{ item.label }}</a>
       <!--   <button
            type="button"
            class="msg-copy-btn"
            @click="copyUrl(item.url, index)"
          >{{ copiedIndex === index ? '已复制' : '复制地址' }}</button> -->
        </div>
          <div class="msg-action-row">
          <a
            href="#"
            class="msg-btn msg-btn-activate"
            @click.prevent="activateCompetition"
          >3D大赛专属激活</a>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
export default {
  name: 'message',
  data() {
    return {
      copiedIndex: -1,
      actionLinks: [
        {
          label: '全国3D大赛数字化设计与制造大赛官网',
          url: 'https://3dshow.3ddl.net/i/DM',
        },
        {
          label: '全国3D大赛数字化设计与制造大赛参赛通知',
          url: 'https://3ddl-oss.oss-cn-beijing.aliyuncs.com/2026/3dds/202619swszhcxtz.pdf',
        },
      ],
    };
  },
  methods: {
    activateCompetition() {
      const payload = { action: 'competitionActivate' };
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(payload, '*');
      }
    },
    openExternal(url) {
      const payload = { action: 'openExternal', url };
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(payload, '*');
      }
    },
    copyUrl(url, index) {
      const done = () => {
        this.copiedIndex = index;
        if (this.copyTimer) clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => {
          this.copiedIndex = -1;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(() => {
          this.fallbackCopy(url, done);
        });
        return;
      }
      this.fallbackCopy(url, done);
    },
    fallbackCopy(text, done) {
      const input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        done();
      } catch (e) {
        // ignore
      }
      document.body.removeChild(input);
    },
  },
  beforeDestroy() {
    if (this.copyTimer) clearTimeout(this.copyTimer);
  },
};
</script>

<style scoped>
/* ── 页面整体 ────────────────────────────────── */
.message-page {
  background: #f5f7fa;
  min-height: 100vh;
  font-family: '微软雅黑', Avenir, Helvetica, Arial, sans-serif;
}

/* ── Hero 区 ─────────────────────────────────── */
.msg-hero {
  background: linear-gradient(135deg, #0055b8 0%, #0078d7 55%, #2ba0e8 100%);
  padding: 3.5rem 1rem 3rem;
  text-align: center;
  color: #fff;
}
.msg-hero-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
}
.msg-trophy {
  font-size: 3.2rem;
  line-height: 1;
  filter: drop-shadow(0 2px 6px rgba(0,0,0,0.25));
}
.msg-title {
  font-size: 2.2rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin: 0;
  text-shadow: 0 2px 8px rgba(0,0,0,0.18);
}
.msg-subtitle {
  font-size: 1.1rem;
  font-weight: 400;
  opacity: 0.92;
  margin: 0;
  letter-spacing: 0.06em;
}

/* ── 主体 ────────────────────────────────────── */
.msg-body {
  padding: 1.2rem 0.8rem 3.5rem;
  max-width: 100%;
  width: 100%;
}

/* ── Section 通用 ────────────────────────────── */
.msg-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.07);
  display: flex;
  gap: 1rem;
  padding: 1.8rem 1.8rem 1.8rem 1.6rem;
  margin-bottom: 1.4rem;
}
.msg-section-icon {
  font-size: 1.6rem;
  line-height: 1.4;
  flex-shrink: 0;
  margin-top: 0.1rem;
}
.msg-section-content {
  flex: 1;
}
.msg-section-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0055b8;
  margin: 0 0 0.5rem;
  border-left: 4px solid #0078d7;
  padding-left: 0.6rem;
}

/* ── 区块副标题 ───────────────────────────────── */
.msg-section-subtitle {
  font-size: 1.1rem;
  color: #0078d7;
  font-weight: 500;
  margin: 0 0 0.9rem 0.1rem;
  letter-spacing: 0.03em;
}

/* ── 正文段落 ─────────────────────────────────── */
.msg-desc {
  font-size: 0.95rem;
  color: #444;
  line-height: 1.85;
  margin: 0 0 0.7rem;
}
.msg-desc:last-child {
  margin-bottom: 0;
}
.msg-sponsor {
  font-size: 0.88rem;
  color: #666;
  padding-top: 0.4rem;
  border-top: 1px dashed #dde3ee;
  margin-top: 0.5rem;
}

/* ── 赛程表格 ─────────────────────────────────── */
.msg-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.93rem;
}
.msg-table thead tr {
  background: #0078d7;
  color: #fff;
}
.msg-table th {
  padding: 0.7rem 1rem;
  font-weight: 600;
  letter-spacing: 0.04em;
}
.msg-table th:first-child { border-radius: 6px 0 0 0; }
.msg-table th:last-child  { border-radius: 0 6px 0 0; text-align: right; }
.msg-table td {
  padding: 0.68rem 1rem;
  border-bottom: 1px solid #e8edf5;
  color: #333;
}
.msg-table tr:last-child td {
  border-bottom: none;
}
.msg-table tbody tr:nth-child(even) {
  background: #f3f7fd;
}
.msg-table tbody tr:hover {
  background: #e6f0fb;
}
.msg-time {
  text-align: right;
  font-variant-numeric: tabular-nums;
  color: #0055b8;
  font-weight: 600;
  white-space: nowrap;
}

/* ── 操作按钮 ─────────────────────────────────── */
.msg-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.4rem;
}
.msg-action-row {
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
}
.msg-btn {
  display: block;
  flex: 1;
  background: #0078d7;
  color: #fff !important;
  text-align: center;
  padding: 0.78rem 1.2rem;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.18s, box-shadow 0.18s;
  box-shadow: 0 2px 8px rgba(0,120,215,0.18);
  letter-spacing: 0.03em;
  box-sizing: border-box;
}
.msg-copy-btn {
  flex-shrink: 0;
  min-width: 5.5rem;
  padding: 0.78rem 0.8rem;
  border: 1px solid #0078d7;
  border-radius: 8px;
  background: #fff;
  color: #0078d7;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
}
.msg-copy-btn:hover {
  background: #e8f2ff;
}
.msg-copy-btn:active {
  background: #d6e8ff;
}
.msg-btn:hover {
  background: #005fa3;
  box-shadow: 0 4px 14px rgba(0,120,215,0.28);
  text-decoration: none;
}
.msg-btn-activate {
  background: #0b6bcb;
  font-weight: 600;
  letter-spacing: 0.06em;
}
.msg-btn-activate:hover {
  background: #0958a8;
}
.msg-btn-accent {
  background: linear-gradient(90deg, #0078d7, #00b0ff);
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.05em;
}
.msg-btn-accent:hover {
  background: linear-gradient(90deg, #005fa3, #0090d4);
}

/* ── 响应式 ──────────────────────────────────── */
@media (max-width: 600px) {
  .msg-title  { font-size: 1.5rem; }
  .msg-subtitle { font-size: 0.92rem; }
  .msg-section { flex-direction: column; gap: 0.5rem; padding: 1.2rem 1rem; }
  .msg-body { padding: 1rem 0.4rem 2.5rem; }
  .msg-table th:last-child,
  .msg-time { text-align: left; }
}
</style>

<!-- 全局重置：让 iframe 内无多余边距 -->
<style>
body:has(.message-page),
html:has(.message-page) {
  margin: 0 !important;
  padding: 0 !important;
  overflow-x: hidden;
}
body:has(.message-page) .container {
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  max-width: 100% !important;
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/message.vue